export const headers = [
  {
    text: 'Data Criação',
    align: 'start',
    sortable: true,
    value: 'createdDate',
    width: '15%'
  },
  {
    text: 'Equipamento',
    align: 'start',
    sortable: true,
    value: 'equipmentName',
    width: '25%'
  },
  {
    text: 'Motorista',
    align: 'start',
    sortable: true,
    value: 'truckDriverName',
    width: '25%'
  },
  {
    text: 'Rede',
    align: 'start',
    sortable: true,
    value: 'codeName',
    width: '20%'
  },
  {
    text: 'Ações',
    value: 'actions',
    align: 'start',
    sortable: false,
    width: '10%'
  }
]